<template>
    <div></div>
</template>
<script>
    import ClickOutside from 'vue-click-outside'
    export default {
        data() {
            return {
                show: false
            }
        },
        directives: {
            ClickOutside
        },
        methods: {
            toggle() {
                this.show = !this.show
            },
            hide() {
                this.show = false
            },
        },
        computed: {
          isActive() {
              return {
                  'is-active': this.show
              }
          }
        },
    }
</script>